import React from 'react'
import Dashboard from '../pages/Dashboard/Dashboard'
import AddClient from '../pages/AddClient/AddClient'
import ViewClient from '../pages/ViewClient/ViewClient'
import Login from '../pages/Login/Login'
import { 
BrowserRouter as Router,
Route,
Switch
} from 'react-router-dom'

const AppRoutes = () => {
    return (
      <Router>
        <Switch>
          <Route exact path="/" component={Dashboard}></Route>
          <Route exact path="/add-clients" component={AddClient}></Route>
          <Route exact path="/view-clients" component={ViewClient}></Route>
          <Route exact path="/login" component={Login}></Route>
        </Switch>
      </Router>
    );
};
  
export default AppRoutes;